import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';
import { Subject } from "rxjs/Rx";

@Injectable()
export class LimitFlowProposalService {

	private apiUrl = globalConst.baseAPI;  // URL para web api
	public proposalReload = new Subject<boolean>();

	public proposalObj: any[] = [];
	public ruralsObj: any[] = [];
	public priceByRegionObj: any[] = [];
	public urbansObj: any[] = [];
	public machinesObj: any[] = [];
	public culturesObj: any[] = [];
	public guaranteesObj: any[] = [];
	public livestocksObj: any[] = [];
	public referencesObj: any[] = [];
	public otherRevenueObj: any[] = [];
	public typeOfObj: any[] = [];
	public segmentsObj: any[] = [];
	public agriculturalPartnershipObj: any[] = [];
	public mainMarketsObj: any[] = [];
	public groupMembers: any[] = [];
	public attachments: any[] = [];

	constructor(private http: Http) { }

	blockProposalField(proposalStatus, isUserOwner): string {
		var rule: string;
		if ((proposalStatus === 'AA' || 
		proposalStatus === 'XE' || 
		proposalStatus === 'XR' || 
		proposalStatus === 'FC' || 
		proposalStatus === 'FA' || 
		proposalStatus === 'FE' || 
		proposalStatus === 'WA' ||
		proposalStatus === 'WG' ||
		proposalStatus === 'AF') || !isUserOwner) {
			rule = 'disabled';
		} else {
			if (proposalStatus === 'AA' || 
			proposalStatus === 'XE' || 
			proposalStatus === 'XR') {
				rule = 'disabled';
			} else {
				rule = null;
			}
		}
		return rule;
	}

	showForm(proposalStatus, isUserOwner): boolean {
		var rule = false;
		if (proposalStatus !== 'AA' && 
		proposalStatus !== 'XE' && 
		proposalStatus !== 'XR' && 
		proposalStatus !== 'FC' && 
		proposalStatus !== 'FA' && 
		proposalStatus !== 'FE' &&
		proposalStatus !== 'WA' &&
		proposalStatus !== 'WG' &&
		proposalStatus !== 'AF') {
			if (isUserOwner) {
				rule = true;
			}
		}

		return rule;
	}

	getProposalLog(proposalID) {
		return this.http
			.get(this.apiUrl + "logs/v1/logsproposal/" + proposalID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	saveProposal(token, data: any, isAutomatic) {

		// Hide loading if called by automatic save
		if (isAutomatic) {
			$(document).find(".ng-progress, .ng-progress.active").hide();
		}

		return this.http
			.post(this.apiUrl + "proposalLC/v1/saveproposalLC/", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getDreFile(id) {
		let localStorageOptions = JSON.parse(localStorage.getItem('yara.connectionHeader'))
		const options = new RequestOptions({ headers: localStorageOptions.headers, responseType: ResponseContentType.Blob });
		return this.http
			.get(this.apiUrl + "proposalLC/v1/downloaddre/" + id, options)
			.map(res => {
				return new Blob([res.blob()], { type: "application/octet-stream" });
			});
	}

	saveDreGroupIntegral(dreList) {
		return this.http
			.post(this.apiUrl + "proposalLC/v1/savedatagroup", dreList, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	editProposal(proposalID) {
		var data = {
			ID: proposalID
		}
		return this.http
			.post(this.apiUrl + "proposalstatus/v1/edit/", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	checkSerasa(proposalID) {
		return this.http
			.get(this.apiUrl + "serasa/v1/proposalLC/" + proposalID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	sendToCtc(obj) {
		return this.http
			.post(this.apiUrl + "proposalstatus/v1/sendCTC/", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	sendToEncerrar(obj) {
		return this.http
			.post(this.apiUrl + "proposalstatus/v1/sendEncerrar", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	sendToComite(obj) {
		return this.http
			.post(this.apiUrl + "proposalstatus/v1/sendComite", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getProposalBlog(proposalID) {
		return this.http
			.get(this.apiUrl + "blog/v1/allbyarea/" + proposalID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getIntegrantes(groupID) {
		return this.http
			.get(this.apiUrl + "proposalLC/v1/getGrupoPropostaLc/" + groupID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	accountHistory(idAccountClient) {
		return this.http
			.get(this.apiUrl + "accounts/v1/gethistoryaccountclient/" + idAccountClient, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	accountHistoryGroup(idGroup) {
		return this.http
			.get(this.apiUrl + "economicgroup/v1/grouphistory/" + idGroup, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	insertBlogComment(obj) {
		return this.http
			.post(this.apiUrl + "blog/v1/insert/", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getBlogUserList(){
		return this.http
			.get(this.apiUrl + "/users/v1/getbloguserlist/", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	sendPreAnalise(obj) {
		return this.http
			.post(this.apiUrl + "proposalstatus/v1/sendpreAnalise/", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	sendToAnalise(obj) {
		return this.http
			.post(this.apiUrl + "proposalstatus/v1/sendAnalise/", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getCtcByAccountClient(id) {
		return this.http
			.get(this.apiUrl + "commercialstructure/v1/getctcbyaccountclient/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getRepresentativeByAccountClient(id) {
		return this.http
			.get(this.apiUrl + "representative/v1/getrepresentativeaccountclient/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	requestCtcPending(obj) {
		return this.http
			.post(this.apiUrl + "proposalstatus/v1/pendenciactc/", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	requestCtcWarranty(obj) {
		return this.http
			.post(this.apiUrl + "proposalstatus/v1/sendAprovarGarantia/", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	requestCtcPendingAproval(obj) {
		return this.http
			.post(this.apiUrl + "proposalstatus/v1/sendAprovarPendente/", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	requestRepresentativePending(obj) {
		return this.http
			.post(this.apiUrl + "proposalstatus/v1/pendenciarepresentante/", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	insertFinancialDemos(data) {
		return this.http
			.post(this.apiUrl + "proposalLC/v1/uploaddrepj", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getFinancialDemosById(id) {
		return this.http
			.get(this.apiUrl + "proposalLC/v1/getdre/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	insertRating(data) {
		return this.http
			.post(this.apiUrl + "proposalLC/v1/uploaddrepf", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getRatingById(id) {
		return this.http
			.get(this.apiUrl + "proposalLC/v1/getdre/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getAutoSaveTimeParameter(token) {
		return this.http
			.get(this.apiUrl + "system/v1/getcodparameterstype/salvamentoauto", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getUserProfileByClient(accountClientId) {
		return this.http
			.get(this.apiUrl + "commercialstructurepaper/v1/getuserprofile/" + accountClientId, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getProposalByAccountClientId(token, accountClientId) {
		return this.http
			.get(this.apiUrl + "proposalLC/v1/getproposalLCbyaccountclient/" + accountClientId, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getPriceByRegion(cityID) {
		return this.http
			.get(this.apiUrl + "costharegion/v1/getbycity/" + cityID + "/?$filter=Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getExperience(token) {
		return this.http
			.get(this.apiUrl + "experiences/v1/getexperience?$filter=Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getArea(token) {
		return this.http
			.get(this.apiUrl + "area/v1/getarea?$filter=Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getAverage(token) {
		return this.http
			.get(this.apiUrl + "averageageofsugarcane/v1/getaverageageofsugarcane/?$filter=Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getGuarantee(token) {
		return this.http
			.get(this.apiUrl + "typeofguarantee/v1/gettypeofguarantees?$filter=Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getPatrimonusByDocument(document) {
		return this.http
			.get(this.apiUrl + "proposalLC/v1/getpatrimoniodocument/" + document, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getRevenuesByDocument(document) {
		return this.http
			.get(this.apiUrl + "proposalLC/v1/getreceitadocument/" + document, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getProductivity(token) {
		return this.http
			.get(this.apiUrl + "productivity/v1/getaverage?$filter=Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getProduct(token) {
		return this.http
			.get(this.apiUrl + "product/v1/getservices?$filter=Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getReveneu(token) {
		return this.http
			.get(this.apiUrl + "revenue/v1/getrevenue?$filter=Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getLive(token) {
		return this.http
			.get(this.apiUrl + "livestocktype/v1/getlivestocktypes?$filter=Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getAccountClienteType(token, guid) {
		return this.http
			.get(this.apiUrl + "accounts/v1/getcustomer/" + guid, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getLcProposal(id) {
		return this.http
			.get(this.apiUrl + "proposalLC/v1/getproposalLC/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getAccountClient(token, doc) {
		var params = {
			Documento: doc
		};

		return this.http
			.post(this.apiUrl + "/accounts/v1/searchcustomer", params, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getCulture(token) {
		return this.http
			.get(this.apiUrl + "culture/v1/getculture?$filter=Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getUserInfos(id) {
		return this.http
			.get(this.apiUrl + "accounts/v1/getcustomer/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getCommercialStructureInfos(codigoSap) {
		return this.http
			.get(this.apiUrl + "commercialstructure/v1/getcommercialstructurebyid/" + codigoSap, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getCultureInfos(estado, cultura) {
		return this.http
			.get(this.apiUrl + "stateculture/v1/getcodculturestate/" + estado + "/" + cultura + "/?$filter=Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getCompany(token) {
		return this.http
			.get(this.apiUrl + "company/v1/getcompany?$filter=Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getAttach(token, idProposal) {
		return this.http
			.get(this.apiUrl + "attachment/v1/getlistattachmentbyproposalid/" + idProposal, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	upAttach(token, data) {
		return this.http
			.post(this.apiUrl + "attachment/v1/uploadattachment", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	downAttach(token, idAttach) {
		return this.http
			.get(this.apiUrl + "attachment/v1/uploadattachment/" + idAttach, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	deleteAttach(token, idAttach) {
		return this.http
			.delete(this.apiUrl + "attachment/v1/uploadattachment/" + idAttach, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	// Tipos de Endividamento
	getProposalypesOfIndebtedness(token, idProposal) {
		return this.http
			.get(this.apiUrl + "proposalculture/v1/getproposalculturebyproposalid/" + idProposal, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	saveTypesOfIndebtedness(token, data) {
		return this.http
			.post(this.apiUrl + "proposalculture/v1/saveproposalculture", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	deleteProposalTypeOfIndebtedness(token, proposalCultureID, idProposal) {
		return this.http
			.delete(this.apiUrl + "proposalculture/v1/inactive/" + proposalCultureID + "/" + idProposal, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getTypes() {
		return this.http
			.get(this.apiUrl + "typeofdebt/v1/typeofdebt?$filter=Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});

	}

	// Culturas
	getProposalCultures(token, idProposal) {
		return this.http
			.get(this.apiUrl + "proposalculture/v1/getproposalculturebyproposalid/" + idProposal, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	saveCulture(token, data) {
		console.log("save culture service", data);
		return this.http
			.post(this.apiUrl + "proposalculture/v1/saveproposalculture", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	deleteProposalCulture(token, proposalCultureID, idProposal) {
		return this.http
			.delete(this.apiUrl + "proposalculture/v1/inactive/" + proposalCultureID + "/" + idProposal, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}


	// Garantias
	getProposalGuarantees(token, idProposal) {
		return this.http
			.get(this.apiUrl + "/proposalwarranty/v1/getproposalwarrantybyproposalid/" + idProposal, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	saveProposalGuarantee(token, data) {
		return this.http
			.post(this.apiUrl + "proposalwarranty/v1/saveproposalwarranty/", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	deleteProposalGuarantee(token, proposalGuaranteeID, idProposal) {
		return this.http
			.delete(this.apiUrl + "proposalwarranty/v1/inactive/" + proposalGuaranteeID + "/" + idProposal, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	// Receitas
	getProposalRevenues(token, idProposal) {
		return this.http
			.get(this.apiUrl + "proposalotherrecipes/v1/getproposalotherrecipesbyproposalid/" + idProposal, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	saveProposalRevenue(token, data) {
		return this.http
			.post(this.apiUrl + "proposalotherrecipes/v1/saveproposalotherrecipes", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	deleteProposalRevenue(token, proposalRevenueID, idProposal) {
		return this.http
			.delete(this.apiUrl + "proposalotherrecipes/v1/inactive/" + proposalRevenueID + "/" + idProposal, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	// Pecuarias
	getProposalLives(token, idProposal) {
		return this.http
			.get(this.apiUrl + "proposalpecuary/v1/getproposalpecuarybyproposalid/" + idProposal, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	saveProposalLive(token, data) {
		return this.http
			.post(this.apiUrl + "proposalpecuary/v1/saveproposalpecuary/", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	deleteProposalLive(token, proposalLiveID, idProposal) {
		return this.http
			.delete(this.apiUrl + "proposalpecuary/v1/inactive/" + proposalLiveID + "/" + idProposal, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	// Necessidade Produto
	getProposalProducts(token, idProposal) {
		return this.http
			.get(this.apiUrl + "proposalnecessaryproduct/v1/getproposalnecessaryproductbyproposalid/" + idProposal, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	saveProposalProduct(token, data) {
		return this.http
			.post(this.apiUrl + "proposalnecessaryproduct/v1/saveproposalnecessaryproduct/", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	deleteProposalProduct(token, proposalProdutcID, idProposal) {
		return this.http
			.delete(this.apiUrl + "proposalnecessaryproduct/v1/inactive/" + proposalProdutcID + "/" + idProposal, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	// Referencias
	getProposalReferences(token, idProposal) {
		return this.http
			.get(this.apiUrl + "proposalreferences/v1/getproposalreferencesbyproposalid/" + idProposal, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	saveProposalReference(token, data) {
		return this.http
			.post(this.apiUrl + "proposalreferences/v1/saveproposalreferences/", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	deleteProposalReference(token, proposalReferenceID, idProposal) {
		return this.http
			.delete(this.apiUrl + "proposalreferences/v1/inactive/" + proposalReferenceID + "/" + idProposal, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getClientType(token) {
		return this.http
			.get(this.apiUrl + "clienttypes/v1/getclienttypes/?$filter=Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}


	//******************************* COMITÊ DE APROVAÇÃO ************************************************//	
	//Retorna o Fluxo de Liberação correpondente ao segmento da proposta.
	getApprovers(segmentID, nivel){
		return this.http
			.get(this.apiUrl + "/flowlimitrelease/v1/getlimit?$orderby=Nivel&$filter=SegmentoID eq guid'"+segmentID+"' and Nivel gt "+nivel+" and Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	//Retorna o Fluxo de comitê especifico para a proposta. 
	getComite(idProposal) {
		return this.http
			.get(this.apiUrl + "comite/v1/proposta/" + idProposal, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	//Adiciona nível de aprovação para a proposta 
	addLevel(idProposal) {
		const newObj = {
			PropostaLCID: idProposal
		}

		return this.http
			.post(this.apiUrl + "comite/v1/adicionarNivel", newObj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	//Salva o apontamento do aprovador (Aprova, Reprova, etc)
	saveApprove(objAtualizar) {

		return this.http
			.post(this.apiUrl + "comite/v1/atualizar", objAtualizar, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}
}



// WEBPACK FOOTER //
// ./src/app/limit-flow-proposal/service/limit-flow-proposal/limit-flow-proposal.service.ts